// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./popoverMenu.scss');
require('ns-popover');

const deps = [
  'nsPopover',
  require('data/user').name,
  require('ui/web/confirmDialog').name,
  require('ui/web/confirmAddNotesDialog').name,
  require('data/collection/benchEvent').name,
  require('data/service/featureFlagService').name,
];

module.exports = angular
  .module('bench.ui.popoverMenu', deps)

  .directive('blPopoverMenu', () => ({
    restrict: 'E',
    scope: {
      documentCollectionId: '=',
      documentId: '=',
      noDpActions: '=',
      canArchive: '=',
    },
    bindToController: true,
    template: require('./popoverMenu.html'),
    controller: require('./popoverMenuCtrl.coffee'),
    controllerAs: 'vm',
  }));
